import { Grid } from "@mui/material";
import React, { useContext, useState } from "react";

import { StyledMainIssueContainer } from "../StyledComponents";
import DiaryEntryIssuesView from "./DiaryEntryIssuesView";
import DiaryEntryRuler from "./DiaryEntryRuler";
import DiaryEntryTable from "./DiaryEntryTable";
import { checkOverlap } from "./helperMethods";

import { useQuery } from "@apollo/client/react";
import { ReportContext } from "@/Contexts/ReportContext";
import { Issue, GetReportIssuesDocument } from "@/graphql/generated/graphql";

const DiaryEntryCalendar: React.FC = () => {
  const [selectedDiaryEntry, setSelectedDiaryEntry] = useState<Issue | null>(null)
  const { selectedReport } = useContext(ReportContext);
  const { data } = useQuery(GetReportIssuesDocument, {
    skip: !selectedReport?.id,
    variables: {
      reportId: selectedReport?.id as string,
    }
  });

  return (
    <Grid size={12}>
      <StyledMainIssueContainer>
        <DiaryEntryRuler />
        <DiaryEntryIssuesView
          positionedIssues={checkOverlap(data?.getReportIssues ? data?.getReportIssues : [])}
          setSelectedIssue={setSelectedDiaryEntry}
        />
      </StyledMainIssueContainer>
      <DiaryEntryTable
        data={data?.getReportIssues ? data?.getReportIssues : []}
        selectedDiaryEntry={selectedDiaryEntry}
        setSelectedDiaryEntry={setSelectedDiaryEntry}
      />
    </Grid>
  );
};

export default DiaryEntryCalendar;
